/*
 * Copyright © 2021 Lexcelon LLC <info@lexcelon.com>
 * Licensed for non-distributable use
 */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Divider,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { isSelected } from './util';

function SideMenu({
  toggle,
  links,
  logo,
  logoDescription,
  backgroundColor,
  textColor,
  accentColor = null,
  logoutUser = null,
  pathname,
}) {
  const [linkMenuAnchorEl, setLinkMenuAnchorEl] = useState(null);
  const [selectedLink, setSelectedLink] = useState(null);

  const handleLinkMenuClick = (event, link) => {
    setLinkMenuAnchorEl(event.currentTarget);
    setSelectedLink(link);
  };

  const handleLinkMenuClose = () => {
    setLinkMenuAnchorEl(null);
    setSelectedLink(null);
  };

  return (
    <div
      role="presentation"
      onKeyDown={toggle}
      style={{
        width: '250px',
        height: '100%',
        backgroundColor: backgroundColor,
      }}
    >
      <List>
        <div
          style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
        >
          <img
            width={150}
            height={150}
            style={{ objectFit: 'contain' }}
            src={logo}
            alt={logoDescription}
            title={logoDescription}
          />
        </div>
        <Divider />
        {links.map((link, index) =>
          link == null ? (
            <Divider key={index} />
          ) : (
            <div key={index}>
              <ListItem
                button
                component={Link}
                to={link.subLinks ? null : link.slug}
                aria-haspopup={link.subLinks ? 'true' : 'false'}
                onClick={
                  link.subLinks
                    ? e => handleLinkMenuClick(e, link)
                    : toggle
                }
                style={{
                  marginRight: '40px',
                  color:
                    !accentColor || isSelected(pathname, link.slug)
                      ? textColor
                      : accentColor,
                  textDecoration:
                    !accentColor && isSelected(pathname, link.slug)
                      ? 'underline'
                      : undefined,
                  textUnderlineOffset: '3px',
                }}
              >
                <ListItemText primary={link.text} />
                {link.subLinks &&
                  (linkMenuAnchorEl && selectedLink?.slug === link.slug ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  ))}
              </ListItem>

              {selectedLink?.subLinks && (
                <Menu
                  id="simple-menu"
                  anchorEl={linkMenuAnchorEl}
                  keepMounted
                  open={Boolean(linkMenuAnchorEl)}
                  onClose={handleLinkMenuClose}
                  elevation={0}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                >
                  {selectedLink?.subLinks.map((subLink, subLinkIndex) => (
                    <MenuItem
                      key={subLinkIndex}
                      component={Link}
                      to={selectedLink?.slug + subLink.slug}
                      onClick={handleLinkMenuClose}
                      style={{ fontSize: '14px' }}
                    >
                      {subLink.text}
                    </MenuItem>
                  ))}
                </Menu>
              )}
            </div>
          )
        )}
        {logoutUser != null && (
          <>
            <Divider />
            <ListItem
              button
              onClick={logoutUser}
              style={{
                marginRight: '40px',
                color: textColor,
              }}
            >
              <ListItemText primary="Logout" />
            </ListItem>
          </>
        )}
        <Divider />
      </List>
    </div>
  );
}

export default SideMenu;